import React from "react"
import {
  Carousel as BSCarousel,
  CarouselProps as BSCarouselProps
} from "react-bootstrap"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "./styles/_carousel.scss"

export interface CarouselProps extends BSCarouselProps {
  items: CarouselItem[] | null | undefined
  interval?: number | null | undefined
  hideControlsForMultiItems?: boolean
  hideIndicatorForMultiItems?: boolean
}

export interface CarouselItem {
  key: string
  content: React.ReactNode
  title: string
}

function CarouselComponent({
  items,
  interval = null,
  hideControlsForMultiItems,
  hideIndicatorForMultiItems,
  className,
  ...rest
}: CarouselProps) {
  const hasOnlyOneItem = items?.length === 1

  return (
    <BSCarousel
      interval={interval}
      controls={!hideControlsForMultiItems && !hasOnlyOneItem}
      indicators={!hideIndicatorForMultiItems && !hasOnlyOneItem}
      className={classNames(className, { "single-item": hasOnlyOneItem })}
      prevIcon={
        <div className="carousel-control-prev-icon">
          <Icon name={IconName.ARROW_NEXT} size={IconSize.XS} />
        </div>
      }
      nextIcon={
        <div className="carousel-control-next-icon">
          <Icon name={IconName.ARROW_NEXT} size={IconSize.XS} />
        </div>
      }
      {...rest}
    >
      {items?.map(item => (
        <BSCarousel.Item key={item.key}>{item.content}</BSCarousel.Item>
      ))}
    </BSCarousel>
  )
}

export const Carousel = React.memo(
  CarouselComponent
) as typeof CarouselComponent
